import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { trackEvent } from '../analytics';

const LINKS = [
  { href: '#home', label: 'Home' },
  { href: '#platform', label: 'Platform' },
  { href: '#pitch-deck', label: 'Pitch Deck' },
  { href: '#gallery', label: 'Gallery' },
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLinkClick = (label) => {
    setOpen(false);
    trackEvent('nav_click', { link: label });
  };

  return (
    <header className={`navbar ${scrolled ? 'navbar--solid' : ''} ${open ? 'navbar--open' : ''}`}>
      <div className="navbar__inner">
        <a href="#home" className="navbar__brand" onClick={() => handleLinkClick('logo')}>
          <span className="navbar__brand-mark">IV</span>
          <span className="navbar__brand-text">
            INIVAYAL
            <small>Agritech Private Limited</small>
          </span>
        </a>

        <nav className="navbar__links">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => handleLinkClick(l.label)}>
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="btn btn-primary navbar__cta"
          onClick={() => handleLinkClick('invest-cta')}
        >
          Invest in Inivayal
        </a>

        <button
          className="navbar__burger"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className="navbar__mobile">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} onClick={() => handleLinkClick(l.label)}>
            {l.label}
          </a>
        ))}
        <a href="#contact" className="btn btn-primary" onClick={() => handleLinkClick('invest-cta-mobile')}>
          Invest in Inivayal
        </a>
      </div>
    </header>
  );
}
